import Link from 'next/link';
import Image from 'next/image';
import { useCallback } from 'react';

import { IProvider } from 'constants/types';
import { Routes } from 'constants/routes';

import { Icon } from 'common/icon';
import { getItemIdentifier } from 'utils/slug';

import styles from './styles.module.css';
import clsx from 'clsx';

export const ProviderCard = ({
  data,
  isWidthStretching,
}: {
  key: string;
  data: IProvider;
  isWidthStretching?: boolean;
}) => {
  const renderIcon = useCallback((counts: number) => {
    if (counts > 10) {
      return <Icon.Smile width="16" height="16" />;
    } else {
      return <Icon.Smile width="16" height="16" />;
    }
  }, []);

  return (
    <div
      className={clsx(styles.container_provider, {
        [styles.widthStretching]: isWidthStretching,
      })}
    >
      <Link prefetch={false} href={Routes.provider(getItemIdentifier(data))}>
        <div className={styles.wrapper_provider}>
          <div className={styles.image}>
            <Image
              alt={data?.name}
              src={data?.imageUrl ?? ''}
              fill
              sizes="160px"
              style={{ objectFit: 'contain', objectPosition: 'center' }}
            />
          </div>

          <div className={styles.provider_card__name}>{data?.name}</div>
          <div className={styles.wrapper_desc}>
            {renderIcon(data?.slotsCount)}
            <span className={styles.wrapper_desc_text}>
              {data?.slotsCount ?? 0} {'slots'}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export const CollectionProviders = ({ data }: { data: IProvider[] }) => {
  const providers = Array.isArray(data) ? data : [];

  return (
    <section>
      <div className={styles.providers_row}>
        {providers.map((provider) => (
          <ProviderCard key={provider?._id?.toString()} data={provider} />
        ))}
      </div>
    </section>
  );
};
